module.exports = {
      id: "check-icon-usage",
      viewBox: "0 0 126 126",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#check-icon",
      toString: function () {
        return this.url;
      }
    }